import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConceptContactModel } from './conceptcontact.model';
import { ConceptContactService } from './conceptcontact.service';
import { MatDialog } from '@angular/material/dialog';
import { ConceptConst, ConceptContactConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { Utils } from '../../../shared/utils';
import { ConceptContactComponent } from './conceptcontact.component';
import { consts } from '../../../consts';
import { ConceptContactDialogDeleteComponent } from './conceptcontact-dialog-delete.component';

@Component({
    selector: 'convfact-conceptcontact-list',
    templateUrl: './conceptcontact-list.component.html',
    styleUrls: ['./conceptcontact.component.css'],
    standalone: false
})
export class ConceptContactListComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private conceptContactService: ConceptContactService,
    public dialog: MatDialog,
    private dummy: DummyComponent
  ) { }

  dataSource: ConceptContactModel[] = [];

  empty = false;
  ready = false;
  all: string[] = [];

  headerTable: any[] = ConceptContactConst.headerTable;

  create(uid: string): void {
    uid = null;
    this.dialog.open(ConceptContactComponent, {
      data: { uid: uid }
    });
  }

  edit(uid: string): void {
    this.dialog.open(ConceptContactComponent, {
      data: { uid: uid }
    });
  }

  delete(uid: string) {
    this.dialog.open(ConceptContactDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      });
  }

  ngOnInit() {
    this.conceptContactService.getList().then(
      data => {
        this.dataSource = data;
        this.ready = true;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      });
  }

}
